export interface AnimeItem {
  id: number;
  title: string;
  cover: string;
  description: string;
  type: string;
  region: string;
  year: number;
  episodes: number;
  latestEpisode: number;
  status: string;
  rating: number;
  views: number;
  updateDate: string;
  tags: string[];
}

export interface CategoryItem {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export interface BannerItem {
  id: number;
  title: string;
  subtitle: string;
  image: string;
  animeId: number;
  tag: string;
}

export const animeList: AnimeItem[] = [
  {
    id: 16982,
    title: '星海远征',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20a%20young%20space%20explorer%20standing%20on%20a%20rocky%20alien%20planet%20under%20a%20vast%20starry%20nebula%2C%20vibrant%20blue%20violet%20and%20teal%20palette%2C%20dramatic%20cosmic%20lighting%2C%20cel%20shaded%20detail%2C%20clean%20deep%20space%20background%2C%20cinematic%20composition&width=400&height=600&seq=anime-cover-01&orientation=portrait',
    description: '当银河航道被未知力量封锁，年轻的领航员带着失落的星图踏上远征。一段关于勇气、羁绊与人类未来的太空史诗就此展开。',
    type: '科幻',
    region: '日本',
    year: 2026,
    episodes: 24,
    latestEpisode: 18,
    status: '连载中',
    rating: 9.4,
    views: 382.6,
    updateDate: '2026-10-13',
    tags: ['太空', '冒险', '机甲', '群像'],
  },
  {
    id: 16983,
    title: '剑与霓虹之城',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20a%20lone%20swordsman%20holding%20a%20glowing%20katana%20in%20a%20rainy%20neon%20cyberpunk%20city%20street%2C%20purple%20and%20orange%20reflections%2C%20moody%20cinematic%20lighting%2C%20detailed%20cel%20shaded%20art%2C%20dark%20blurred%20urban%20background&width=400&height=600&seq=anime-cover-02&orientation=portrait',
    description: '在永夜不眠的霓虹都市，一名背负旧约的剑客追踪着操纵记忆的幕后黑手。刀光与数据的边界，是他唯一的战场。',
    type: '奇幻',
    region: '中国',
    year: 2025,
    episodes: 12,
    latestEpisode: 12,
    status: '已完结',
    rating: 8.9,
    views: 268.4,
    updateDate: '2026-09-28',
    tags: ['赛博朋克', '剑戟', '悬疑'],
  },
  {
    id: 16984,
    title: '时之魔法少女',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20a%20magical%20girl%20with%20long%20flowing%20hair%20surrounded%20by%20glowing%20clock%20gears%20and%20sparkles%2C%20pastel%20pink%20and%20violet%20palette%2C%20soft%20dreamy%20lighting%2C%20detailed%20cel%20shaded%20linework%2C%20clean%20fantasy%20background&width=400&height=600&seq=anime-cover-03&orientation=portrait',
    description: '每当钟声响起，平凡的少女便会踏入被折叠的时间之中。为了守护即将消失的明天，她选择与时间本身为敌。',
    type: '少女',
    region: '日本',
    year: 2026,
    episodes: 24,
    latestEpisode: 15,
    status: '连载中',
    rating: 9.1,
    views: 301.2,
    updateDate: '2026-10-12',
    tags: ['魔法', '时间', '成长', '治愈'],
  },
  {
    id: 16985,
    title: '龙脊学院',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20a%20teenage%20dragon%20rider%20student%20standing%20before%20a%20grand%20castle%20academy%20on%20a%20cliff%2C%20emerald%20green%20and%20gold%20palette%2C%20epic%20daylight%20lighting%2C%20detailed%20cel%20shaded%20art%2C%20clean%20mountain%20background&width=400&height=600&seq=anime-cover-04&orientation=portrait',
    description: '在被龙脊山脉环绕的古老学院里，出身平凡的少年唤醒了沉睡千年的龙心。血统不是终点，选择才是。',
    type: '少年',
    region: '日本',
    year: 2025,
    episodes: 25,
    latestEpisode: 25,
    status: '已完结',
    rating: 8.7,
    views: 244.8,
    updateDate: '2026-09-20',
    tags: ['学院', '龙', '成长', '友情'],
  },
  {
    id: 16986,
    title: '深海回响',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20a%20diver%20floating%20in%20a%20deep%20mysterious%20ocean%20among%20glowing%20jellyfish%20and%20ancient%20ruins%2C%20deep%20teal%20and%20cyan%20palette%2C%20ethereal%20underwater%20lighting%2C%20cel%20shaded%20detail%2C%20clean%20deep%20sea%20background&width=400&height=600&seq=anime-cover-05&orientation=portrait',
    description: '一段来自深海的低语唤醒了沉睡的文明。潜航员们在无声的黑暗中，找到了比宝藏更危险的东西——真相。',
    type: '科幻',
    region: '日本',
    year: 2026,
    episodes: 16,
    latestEpisode: 9,
    status: '连载中',
    rating: 8.8,
    views: 187.3,
    updateDate: '2026-10-10',
    tags: ['深海', '悬疑', '文明'],
  },
  {
    id: 16987,
    title: '樱色恋歌',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20two%20students%20under%20blooming%20cherry%20blossom%20trees%20on%20a%20quiet%20school%20path%2C%20soft%20pink%20and%20warm%20cream%20palette%2C%20gentle%20sunset%20lighting%2C%20delicate%20cel%20shaded%20art%2C%20clean%20soft%20background&width=400&height=600&seq=anime-cover-06&orientation=portrait',
    description: '转学第一天，她捡到了一封没有署名的信。樱花飘落的三个月里，两个人小心翼翼地靠近，又笨拙地守护着彼此。',
    type: '恋爱',
    region: '日本',
    year: 2026,
    episodes: 12,
    latestEpisode: 12,
    status: '已完结',
    rating: 9.0,
    views: 276.5,
    updateDate: '2026-09-30',
    tags: ['校园', '恋爱', '治愈'],
  },
  {
    id: 16988,
    title: '机械之心',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20a%20giant%20humanoid%20mecha%20robot%20kneeling%20in%20a%20ruined%20city%20with%20a%20pilot%20cockpit%20glowing%2C%20steel%20gray%20and%20orange%20palette%2C%20dramatic%20battle%20lighting%2C%20detailed%20cel%20shaded%20mecha%20design%2C%20clean%20dusty%20sky%20background&width=400&height=600&seq=anime-cover-07&orientation=portrait',
    description: '当战争机器第一次流下眼泪，人类才意识到它早已拥有了心。一名少年驾驶员与他的机体，正驶向被隐瞒的真相。',
    type: '热血',
    region: '日本',
    year: 2025,
    episodes: 26,
    latestEpisode: 26,
    status: '已完结',
    rating: 9.2,
    views: 355.9,
    updateDate: '2026-08-25',
    tags: ['机甲', '战争', '热血', '成长'],
  },
  {
    id: 16989,
    title: '猫町日常',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20a%20cozy%20small%20town%20street%20with%20a%20friendly%20cat%20sitting%20on%20a%20fence%20by%20a%20traditional%20cafe%2C%20warm%20cream%20and%20sage%20green%20palette%2C%20soft%20afternoon%20lighting%2C%20gentle%20cel%20shaded%20art%2C%20clean%20charming%20background&width=400&height=600&seq=anime-cover-08&orientation=portrait',
    description: '小镇的每个角落都藏着小小的温柔。一只会选人的猫、一间不打烊的咖啡馆，和一群把日子过成诗的人。',
    type: '日常',
    region: '日本',
    year: 2026,
    episodes: 13,
    latestEpisode: 13,
    status: '已完结',
    rating: 8.6,
    views: 162.1,
    updateDate: '2026-09-15',
    tags: ['治愈', '日常', '猫咪'],
  },
  {
    id: 16990,
    title: '雾隐侦探社',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20a%20young%20detective%20in%20a%20trench%20coat%20holding%20a%20magnifying%20glass%20on%20a%20foggy%20old%20city%20street%20at%20dusk%2C%20desaturated%20blue%20gray%20palette%20with%20amber%20lamplight%2C%20moody%20cinematic%20lighting%2C%20cel%20shaded%20art%2C%20clean%20foggy%20background&width=400&height=600&seq=anime-cover-09&orientation=portrait',
    description: '雾隐町的犯罪从不会留下痕迹，除了他。年轻的侦探用逻辑拆解每一桩诡计，却在最后一个案子里遇到了自己。',
    type: '悬疑',
    region: '中国',
    year: 2026,
    episodes: 20,
    latestEpisode: 11,
    status: '连载中',
    rating: 9.3,
    views: 298.7,
    updateDate: '2026-10-14',
    tags: ['推理', '悬疑', '犯罪'],
  },
  {
    id: 16991,
    title: '焰之剑士',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20a%20fierce%20young%20warrior%20swinging%20a%20flaming%20sword%20in%20a%20battle%20arena%2C%20fiery%20red%20and%20gold%20palette%2C%20explosive%20dynamic%20lighting%2C%20detailed%20cel%20shaded%20action%20art%2C%20clean%20ember%20background&width=400&height=600&seq=anime-cover-10&orientation=portrait',
    description: '被逐出师门的少年握住了那柄无人敢碰的炎剑。他要证明的不是天赋，而是那份永不熄灭的倔强。',
    type: '热血',
    region: '日本',
    year: 2025,
    episodes: 24,
    latestEpisode: 24,
    status: '已完结',
    rating: 8.5,
    views: 231.0,
    updateDate: '2026-07-18',
    tags: ['热血', '剑戟', '成长'],
  },
  {
    id: 16992,
    title: '云端飞行日记',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20a%20teenage%20pilot%20girl%20flying%20a%20small%20propeller%20plane%20above%20fluffy%20clouds%20at%20sunrise%2C%20sky%20blue%20and%20warm%20orange%20palette%2C%20bright%20airy%20lighting%2C%20cel%20shaded%20art%2C%20clean%20cloud%20background&width=400&height=600&seq=anime-cover-11&orientation=portrait',
    description: '为了完成祖父未竟的航线，少女驾驶着老旧飞机飞向天空尽头。风、云与引擎声，是她写给天空的情书。',
    type: '少年',
    region: '日本',
    year: 2026,
    episodes: 13,
    latestEpisode: 6,
    status: '连载中',
    rating: 8.4,
    views: 121.6,
    updateDate: '2026-10-08',
    tags: ['飞行', '梦想', '青春'],
  },
  {
    id: 16993,
    title: '幻境食灵',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20a%20cheerful%20young%20chef%20cooking%20magical%20glowing%20food%20with%20tiny%20spirits%20floating%20around%2C%20warm%20amber%20and%20emerald%20palette%2C%20cozy%20fantasy%20lantern%20lighting%2C%20cel%20shaded%20art%2C%20clean%20wooden%20kitchen%20background&width=400&height=600&seq=anime-cover-12&orientation=portrait',
    description: '只有用心做出的料理才能唤醒食灵。年轻的厨师带着神秘食谱走遍幻境，用一道道美食治愈人与妖怪的伤痕。',
    type: '奇幻',
    region: '中国',
    year: 2026,
    episodes: 15,
    latestEpisode: 8,
    status: '连载中',
    rating: 8.9,
    views: 176.4,
    updateDate: '2026-10-11',
    tags: ['美食', '妖怪', '治愈'],
  },
  {
    id: 16994,
    title: '逆光奔跑',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20a%20determined%20high%20school%20track%20runner%20sprinting%20on%20a%20stadium%20track%20at%20golden%20hour%2C%20dynamic%20orange%20and%20blue%20palette%2C%20energetic%20backlit%20lighting%2C%20detailed%20cel%20shaded%20action%20art%2C%20clean%20stadium%20background&width=400&height=600&seq=anime-cover-13&orientation=portrait',
    description: '伤愈复出的短跑选手只剩下最后一年。他要追上的不是对手，而是那个曾经想放弃的自己。',
    type: '少年',
    region: '日本',
    year: 2026,
    episodes: 24,
    latestEpisode: 14,
    status: '连载中',
    rating: 8.7,
    views: 203.5,
    updateDate: '2026-10-07',
    tags: ['竞技', '热血', '青春'],
  },
  {
    id: 16995,
    title: '月下妖歌',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20an%20elegant%20fox%20spirit%20woman%20singing%20under%20a%20full%20moon%20on%20a%20traditional%20shrine%20roof%2C%20deep%20violet%20and%20silver%20palette%2C%20mystical%20moonlight%20glow%2C%20detailed%20cel%20shaded%20art%2C%20clean%20night%20sky%20background&width=400&height=600&seq=anime-cover-14&orientation=portrait',
    description: '月圆之夜，妖怪的歌谣会勾走迷路者的心。一位能听懂妖歌的少年，踏进了人与妖纠缠百年的旧约。',
    type: '奇幻',
    region: '日本',
    year: 2025,
    episodes: 26,
    latestEpisode: 26,
    status: '已完结',
    rating: 9.1,
    views: 320.8,
    updateDate: '2026-08-02',
    tags: ['妖怪', '和风', '民俗'],
  },
  {
    id: 16996,
    title: '银河邮差',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20a%20solo%20space%20courier%20delivering%20a%20parcel%20aboard%20a%20small%20spaceship%20docking%20at%20a%20ring%20space%20station%2C%20cool%20indigo%20and%20warm%20amber%20palette%2C%20soft%20sci%20fi%20lighting%2C%20cel%20shaded%20art%2C%20clean%20orbit%20background&width=400&height=600&seq=anime-cover-15&orientation=portrait',
    description: '在星际之间运送信件是最孤独也最浪漫的职业。一封迟到了十年的信，把他带向了宇宙的另一端。',
    type: '科幻',
    region: '日本',
    year: 2026,
    episodes: 12,
    latestEpisode: 12,
    status: '已完结',
    rating: 9.0,
    views: 198.2,
    updateDate: '2026-09-22',
    tags: ['科幻', '治愈', '公路'],
  },
  {
    id: 16997,
    title: '泡沫之夏',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustrated%20key%20visual%20poster%20of%20a%20group%20of%20friends%20running%20along%20a%20sunny%20beach%20shoreline%20with%20splashing%20waves%20at%20summer%20noon%2C%20turquoise%20and%20coral%20palette%2C%20bright%20joyful%20lighting%2C%20cel%20shaded%20art%2C%20clean%20ocean%20sky%20background&width=400&height=600&seq=anime-cover-16&orientation=portrait',
    description: '那个夏天，四个少年在海边小城许下了永不分开的约定。多年后归来，潮水带走了什么，又留下了什么。',
    type: '日常',
    region: '中国',
    year: 2026,
    episodes: 16,
    latestEpisode: 16,
    status: '已完结',
    rating: 8.6,
    views: 154.7,
    updateDate: '2026-09-05',
    tags: ['青春', '友情', '夏日'],
  },
];

export const categories: CategoryItem[] = [
  { slug: '少年', name: '少年', icon: 'ri-sword-line', description: '热血成长与冒险羁绊，少年向佳作聚合' },
  { slug: '少女', name: '少女', icon: 'ri-heart-3-line', description: '温柔细腻的少女向故事与情感共鸣' },
  { slug: '热血', name: '热血', icon: 'ri-fire-line', description: '燃到极致的战斗与不屈意志' },
  { slug: '奇幻', name: '奇幻', icon: 'ri-magic-line', description: '魔法、异世界与瑰丽想象的舞台' },
  { slug: '科幻', name: '科幻', icon: 'ri-rocket-2-line', description: '星际、机甲与未来科技的远征' },
  { slug: '恋爱', name: '恋爱', icon: 'ri-heart-2-line', description: '心动瞬间与酸甜交织的青春物语' },
  { slug: '日常', name: '日常', icon: 'ri-sun-line', description: '治愈系生活切片与温暖小确幸' },
  { slug: '悬疑', name: '悬疑', icon: 'ri-spy-line', description: '推理、迷局与层层反转的烧脑体验' },
];

export const banners: BannerItem[] = [
  {
    id: 1,
    title: '星海远征',
    subtitle: '当银河航道被封锁，一段关于勇气与羁绊的太空史诗就此启航。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20anime%20style%20wide%20banner%20of%20a%20space%20explorer%20facing%20a%20colossal%20glowing%20nebula%20and%20distant%20planet%2C%20dramatic%20blue%20violet%20and%20teal%20space%20palette%2C%20epic%20cosmic%20lighting%2C%20detailed%20cel%20shaded%20illustration%2C%20dark%20edges%20suitable%20for%20text%20overlay&width=1920&height=800&seq=anime-banner-01&orientation=landscape',
    animeId: 16982,
    tag: '最新连载',
  },
  {
    id: 2,
    title: '剑与霓虹之城',
    subtitle: '霓虹不眠，旧约未了。刀光与数据的边界，是他唯一的战场。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20anime%20style%20wide%20banner%20of%20a%20lone%20swordsman%20with%20a%20glowing%20katana%20in%20a%20rainy%20neon%20cyberpunk%20megacity%2C%20purple%20and%20orange%20reflection%20palette%2C%20moody%20cinematic%20lighting%2C%20detailed%20cel%20shaded%20illustration%2C%20dark%20edges%20suitable%20for%20text%20overlay&width=1920&height=800&seq=anime-banner-02&orientation=landscape',
    animeId: 16983,
    tag: '高分推荐',
  },
  {
    id: 3,
    title: '时之魔法少女',
    subtitle: '每当钟声响起，平凡的少女便会踏入被折叠的时间之中。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20anime%20style%20wide%20banner%20of%20a%20magical%20girl%20surrounded%20by%20floating%20glowing%20clock%20gears%20in%20a%20surreal%20time%20void%2C%20pastel%20pink%20violet%20and%20gold%20palette%2C%20dreamy%20magical%20lighting%2C%20detailed%20cel%20shaded%20illustration%2C%20dark%20edges%20suitable%20for%20text%20overlay&width=1920&height=800&seq=anime-banner-03&orientation=landscape',
    animeId: 16984,
    tag: '本周热门',
  },
  {
    id: 4,
    title: '雾隐侦探社',
    subtitle: '雾隐町的犯罪从不会留下痕迹，除了他。层层反转的推理之旅。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20anime%20style%20wide%20banner%20of%20a%20young%20detective%20silhouette%20in%20a%20foggy%20old%20city%20street%20lit%20by%20amber%20streetlamps%2C%20desaturated%20blue%20gray%20and%20amber%20palette%2C%20moody%20mystery%20lighting%2C%20detailed%20cel%20shaded%20illustration%2C%20dark%20edges%20suitable%20for%20text%20overlay&width=1920&height=800&seq=anime-banner-04&orientation=landscape',
    animeId: 16990,
    tag: '烧脑悬疑',
  },
];

export const regionOptions: string[] = ['全部', '日本', '中国', '美国'];

export const yearOptions: number[] = [2026, 2025, 2024, 2023];

export const sortOptions: { key: string; label: string }[] = [
  { key: 'update', label: '按更新时间' },
  { key: 'hot', label: '按热度' },
  { key: 'rating', label: '按评分' },
];